const AttentionIcon = (props: any) => {
  return (
    <svg
      width={props.width || '124'}
      height={props.width || '124'}
      viewBox='0 0 124 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='8.57188'
        y='27.0216'
        width='89.9437'
        height='89.9437'
        rx='24.2156'
        fill='url(#paint0_linear_2905_8374)'
        stroke='url(#paint1_linear_2905_8374)'
        strokeWidth='0.76875'
      />
      <g filter='url(#filter0_b_2905_8374)'>
        <mask id='path-2-inside-1_2905_8374' fill='white'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M49.6996 6.6499C36.1134 6.6499 25.0996 17.6637 25.0996 31.2499V72.7624C25.0996 86.3486 36.1134 97.3624 49.6996 97.3624H91.2121C104.798 97.3624 115.812 86.3486 115.812 72.7624V31.2499C115.812 17.6637 104.798 6.6499 91.2121 6.6499H49.6996ZM66.6496 70.1586C65.5996 71.1656 65.0746 72.3671 65.0746 73.7631C65.0746 75.182 65.5996 76.395 66.6496 77.4019C67.7246 78.4089 69.2496 78.9124 71.2246 78.9124C73.2246 78.9124 74.7496 78.4089 75.7996 77.4019C76.8496 76.395 77.3746 75.182 77.3746 73.7631C77.3746 72.3671 76.8371 71.1656 75.7621 70.1586C74.7121 69.1517 73.1996 68.6482 71.2246 68.6482C69.2496 68.6482 67.7246 69.1517 66.6496 70.1586ZM66.8188 58.5352C66.8707 60.9313 68.8279 62.8467 71.2246 62.8467C73.6213 62.8467 75.5785 60.9313 75.6304 58.5352L76.1776 33.2362C76.2377 30.4588 74.0027 28.1749 71.2246 28.1749C68.4466 28.1749 66.2115 30.4588 66.2716 33.2362L66.8188 58.5352Z'
          />
        </mask>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M49.6996 6.6499C36.1134 6.6499 25.0996 17.6637 25.0996 31.2499V72.7624C25.0996 86.3486 36.1134 97.3624 49.6996 97.3624H91.2121C104.798 97.3624 115.812 86.3486 115.812 72.7624V31.2499C115.812 17.6637 104.798 6.6499 91.2121 6.6499H49.6996ZM66.6496 70.1586C65.5996 71.1656 65.0746 72.3671 65.0746 73.7631C65.0746 75.182 65.5996 76.395 66.6496 77.4019C67.7246 78.4089 69.2496 78.9124 71.2246 78.9124C73.2246 78.9124 74.7496 78.4089 75.7996 77.4019C76.8496 76.395 77.3746 75.182 77.3746 73.7631C77.3746 72.3671 76.8371 71.1656 75.7621 70.1586C74.7121 69.1517 73.1996 68.6482 71.2246 68.6482C69.2496 68.6482 67.7246 69.1517 66.6496 70.1586ZM66.8188 58.5352C66.8707 60.9313 68.8279 62.8467 71.2246 62.8467C73.6213 62.8467 75.5785 60.9313 75.6304 58.5352L76.1776 33.2362C76.2377 30.4588 74.0027 28.1749 71.2246 28.1749C68.4466 28.1749 66.2115 30.4588 66.2716 33.2362L66.8188 58.5352Z'
          fill='url(#paint2_linear_2905_8374)'
          fillOpacity='0.7'
        />
        <path
          d='M66.6496 70.1586L66.124 69.5975L66.1175 69.6038L66.6496 70.1586ZM66.6496 77.4019L66.1175 77.9568L66.1241 77.963L66.6496 77.4019ZM75.7996 77.4019L76.3317 77.9568L76.3317 77.9568L75.7996 77.4019ZM75.7621 70.1586L75.23 70.7135L75.2366 70.7197L75.7621 70.1586ZM66.8188 58.5352L67.5874 58.5186L67.5874 58.5186L66.8188 58.5352ZM75.6304 58.5352L74.8618 58.5186L74.8618 58.5186L75.6304 58.5352ZM76.1776 33.2362L75.4091 33.2196L75.4091 33.2196L76.1776 33.2362ZM66.2716 33.2362L65.503 33.2528L65.503 33.2528L66.2716 33.2362ZM25.8684 31.2499C25.8684 18.0883 36.538 7.41865 49.6996 7.41865V5.88115C35.6888 5.88115 24.3309 17.2392 24.3309 31.2499H25.8684ZM25.8684 72.7624V31.2499H24.3309V72.7624H25.8684ZM49.6996 96.5937C36.538 96.5937 25.8684 85.924 25.8684 72.7624H24.3309C24.3309 86.7732 35.6889 98.1312 49.6996 98.1312V96.5937ZM91.2121 96.5937H49.6996V98.1312H91.2121V96.5937ZM115.043 72.7624C115.043 85.924 104.374 96.5937 91.2121 96.5937V98.1312C105.223 98.1312 116.581 86.7731 116.581 72.7624H115.043ZM115.043 31.2499V72.7624H116.581V31.2499H115.043ZM91.2121 7.41865C104.374 7.41865 115.043 18.0883 115.043 31.2499H116.581C116.581 17.2391 105.223 5.88115 91.2121 5.88115V7.41865ZM49.6996 7.41865H91.2121V5.88115H49.6996V7.41865ZM65.8434 73.7631C65.8434 72.5863 66.2757 71.5823 67.1817 70.7135L66.1175 69.6038C64.9235 70.7489 64.3059 72.1479 64.3059 73.7631H65.8434ZM67.1817 76.8471C66.2786 75.981 65.8434 74.9667 65.8434 73.7631H64.3059C64.3059 75.3974 64.9206 76.809 66.1175 77.9568L67.1817 76.8471ZM71.2246 78.1437C69.3769 78.1437 68.0648 77.6743 67.1752 76.8409L66.1241 77.963C67.3844 79.1435 69.1223 79.6812 71.2246 79.6812V78.1437ZM75.2675 76.8471C74.4071 77.6722 73.1017 78.1437 71.2246 78.1437V79.6812C73.3475 79.6812 75.0921 79.1456 76.3317 77.9568L75.2675 76.8471ZM76.6059 73.7631C76.6059 74.9667 76.1706 75.981 75.2675 76.8471L76.3317 77.9568C77.5286 76.809 78.1434 75.3974 78.1434 73.7631H76.6059ZM75.2366 70.7197C76.166 71.5903 76.6059 72.5925 76.6059 73.7631H78.1434C78.1434 72.1417 77.5082 70.7409 76.2877 69.5976L75.2366 70.7197ZM71.2246 69.4169C73.0736 69.4169 74.368 69.8868 75.23 70.7135L76.2942 69.6038C75.0562 68.4166 73.3256 67.8794 71.2246 67.8794V69.4169ZM67.1752 70.7197C68.0648 69.8863 69.3769 69.4169 71.2246 69.4169V67.8794C69.1223 67.8794 67.3844 68.417 66.1241 69.5976L67.1752 70.7197ZM71.2246 62.0779C69.246 62.0779 67.6302 60.4967 67.5874 58.5186L66.0503 58.5518C66.1111 61.3659 68.4099 63.6154 71.2246 63.6154V62.0779ZM74.8618 58.5186C74.819 60.4967 73.2032 62.0779 71.2246 62.0779V63.6154C74.0394 63.6154 76.3381 61.3659 76.3989 58.5518L74.8618 58.5186ZM75.4091 33.2196L74.8618 58.5186L76.3989 58.5518L76.9462 33.2528L75.4091 33.2196ZM71.2246 28.9437C73.5716 28.9437 75.4598 30.8732 75.4091 33.2196L76.9462 33.2528C77.0156 30.0445 74.4337 27.4062 71.2246 27.4062V28.9437ZM67.0402 33.2196C66.9894 30.8732 68.8776 28.9437 71.2246 28.9437V27.4062C68.0155 27.4062 65.4336 30.0445 65.503 33.2528L67.0402 33.2196ZM67.5874 58.5186L67.0402 33.2196L65.503 33.2528L66.0503 58.5518L67.5874 58.5186Z'
          fill='url(#paint3_linear_2905_8374)'
          fillOpacity='0.9'
          mask='url(#path-2-inside-1_2905_8374)'
        />
      </g>
      <defs>
        <filter
          id='filter0_b_2905_8374'
          x='15.8746'
          y='-2.5751'
          width='109.163'
          height='109.162'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='4.6125' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_2905_8374'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_2905_8374'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_2905_8374'
          x1='8.1875'
          y1='26.6372'
          x2='98.9'
          y2='117.35'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FAD34A' />
          <stop offset='1' stopColor='#FFC736' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2905_8374'
          x1='12.8'
          y1='32.0185'
          x2='90.4437'
          y2='121.193'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F4EDC8' />
          <stop offset='1' stopColor='#E1CB58' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2905_8374'
          x1='25.0996'
          y1='6.6499'
          x2='115.812'
          y2='97.3624'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FEFDDC' />
          <stop offset='1' stopColor='#FFF6E3' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_2905_8374'
          x1='29.7121'
          y1='12.0312'
          x2='107.356'
          y2='101.206'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFF3CA' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AttentionIcon;
